import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';

const styles = StyleSheet.create({
  pointDrawingContainer: {
    marginHorizontal: commonStyles.marginHorizontal,
    marginBottom: '3%',
  },
  pointDrawingTitleWrapper: {
    ...commonStyles.fontM,
    flexDirection: 'row',
    fontWeight: 'bold',
    marginBottom: '1.5%',
  },
  pointDrawingTitle: {
    marginRight: 13,
  },
  pointDrawing: {
    objectFit: 'contain',
    width: '100%',
    border: '1.5px solid #000',
    borderRadius: 4,
    padding: '1%',
    maxHeight: 455,
  },
});

function PointDrawing({ point, pointIndex, projection, t }) {
  return (
    <View style={styles.pointDrawingContainer} wrap={false}>
      <View style={styles.pointDrawingTitleWrapper}>
        <Text style={styles.pointDrawingTitle}>
          {t(point.typeCode === 'DESIGNER' ? 'product_shortcut' : 'constructive_shortcut')}
          {pointIndex + 1}
        </Text>
        <Text>{`${t('drawing_shortcut')} ${projection.number}.${point.photoNumber}`}</Text>
      </View>
      <Image style={styles.pointDrawing} src={point.photo} />
    </View>
  );
}

export default withTranslation('specification')(PointDrawing);
